import React, { useState } from "react";
import { CircularProgress, styled } from "@mui/material";
import { InviteData } from "../../util/sendInvitaion";
import { ClinicFormInput } from "../../elements/clinicFormInput";
import { ClinicActionButton } from "fe-web-components/clinic/clinicActionButton";
import { localeSettings } from "../../clinicSettings/localeDefaults";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import getTime from "date-fns/getTime";
import { ClinicDateTimePicker } from "../../elements/clinicDateTimePicker";
//region [[ Styles ]]

const FormActions = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  paddingBottom: 16,
  paddingTop: 8,
});

const SavingProgress = styled("span")({
  display: "flex",
  alignItems: "center",
  gap: 6,
  margin: "0 6px",
});

export interface InviteFormProps {
  inviteData: InviteData;
  onSubmit: (inviteData: InviteData) => void;
  defaultLocale?: string;
  validateForm?: (inviteFormData: InviteFormData) => boolean;
  buttonLabel?: string;
  saving?: boolean;
}

export interface InviteFormData {
  fullName?: string;
  phoneNumber?: string;
  email?: string;
  visitDateTime?: number;
}

//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]

export const InviteForm = ({ ...props }: InviteFormProps) => {
  const { inviteData, defaultLocale } = props;
  const [phoneNumber, setPhoneNumber] = useState<string>(
    inviteData.patient.phoneNumber,
  );
  const [email, setEmail] = useState<string>(inviteData.patient.email);
  const [fullName, setFullName] = useState(
    [inviteData.patient.firstName, inviteData.patient.lastName]
      .filter(Boolean)
      .join(" "),
  );
  const toTimeStamp = (dateTimeStr: Date): number => {
    return dateTimeStr ? getTime(dateTimeStr) : null;
  };

  const [visitDateTime, setVisitDateTime] = useState<number>(
    props.inviteData.visitDateTime,
  );

  const saveInvite = () => {
    const patientName = fullName.split(" ").filter(Boolean);
    props.onSubmit({
      ...inviteData,
      patient: {
        ...inviteData.patient,
        firstName: patientName[0],
        lastName: patientName.length > 1 ? patientName.slice(1).join(" ") : "",
        email,
        phoneNumber: phoneNumber
          ? phoneNumber.startsWith("+")
            ? phoneNumber
            : "+" + phoneNumber
          : null,
      },
      visitDateTime: visitDateTime,
    });
  };

  return (
    <div className="invite-form">
      <div>
        <ClinicFormInput
          id="fullName"
          label="Patient Full Name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />
        <ClinicFormInput
          id="phone"
          label="Phone number"
          customInput={
            <PhoneInput
              enableSearch={true}
              value={phoneNumber}
              country={
                localStorage.getItem("lastCountryCode") ||
                localeSettings[defaultLocale]?.country
              }
              onChange={(phone, countryData) => {
                localStorage.setItem(
                  "lastCountryCode",
                  countryData["countryCode"],
                );
                setPhoneNumber(phone);
              }}
              inputStyle={{ height: 43 }}
            />
          }
        />
        <ClinicFormInput
          id="email"
          label="Email address"
          value={email || ""}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
        />
        <ClinicFormInput
          id="visitTime"
          label="Time of visit"
          customInput={
            <ClinicDateTimePicker
              showTime={true}
              value={visitDateTime && new Date(visitDateTime)}
              onChange={(dateVal) => {
                return setVisitDateTime(toTimeStamp(dateVal));
              }}
              locale={defaultLocale}
              disablePast={true}
              minDateMessage={"You cannot set past dates for time of visit"}
            />
          }
        />
      </div>
      <FormActions>
        <ClinicActionButton
          onClick={() => saveInvite()}
          disabled={
            (props.validateForm &&
              !props.validateForm({
                fullName,
                phoneNumber,
                email,
                visitDateTime,
              })) ||
            props.saving
          }
          label={
            props.saving ? (
              <SavingProgress>
                <CircularProgress size={18} />{" "}
                {props.inviteData.isNew ? "Adding" : "Saving"} patient...
              </SavingProgress>
            ) : (
              props.buttonLabel || (props.inviteData.isNew ? "Add" : "Save")
            )
          }
        />
      </FormActions>
    </div>
  );
};
